var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "gray-area", attrs: { id: "content" } }, [
    _c("div", { staticClass: "container" }, [
      _c(
        "div",
        { staticClass: "row" },
        [
          _c("sdr-breadcrumbs", {
            attrs: { active_item: "second", module: _vm.modulo },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "form",
          {
            on: {
              submit: function ($event) {
                $event.preventDefault()
                return _vm.onSubmit($event)
              },
            },
          },
          [
            _c("div", { staticClass: "container shortcode travel-ideas" }, [
              _vm.get_areWeInServicesBookingNoMode === false
                ? _c(
                    "h1",
                    {
                      staticClass: "idea-title",
                      staticStyle: { "margin-bottom": "20px" },
                    },
                    [
                      _vm._m(0),
                      _vm._v(
                        _vm._s(
                          _vm.pleaseselectservicesheadline[_vm.getCurrentLocale]
                        ) + "\n                    "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.get_areWeInServicesBookingNoMode === true
                ? _c(
                    "h1",
                    {
                      staticClass: "idea-title",
                      staticStyle: { "margin-bottom": "20px" },
                    },
                    [
                      _vm._m(1),
                      _vm._v(
                        _vm._s(
                          _vm.pleaseselectservicesheadlineinbookinno[
                            _vm.getCurrentLocale
                          ]
                        ) + "\n                    "
                      ),
                    ]
                  )
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "col-sms-6 col-sm-8 col-md-9",
                attrs: { id: "main" },
              },
              [
                _c("sdr-passenger", { attrs: { modulo: _vm.modulo } }),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _vm.getFlagBookingPassengersAreReadyForValidation === true
                  ? _c(
                      "button",
                      {
                        staticClass:
                          "btn-large icon-check uppercase full-width",
                        class: {
                          sundairsrvcs: _vm.modulo === "services",
                          "icon-check3": _vm.modulo === "services",
                        },
                        attrs: { type: "submit" },
                      },
                      [_vm._v(_vm._s(_vm.proceed[_vm.getCurrentLocale]))]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.getFlagBookingPassengersAreReadyForValidation !== true
                  ? _c(
                      "a",
                      {
                        staticClass:
                          "button btn-large uppercase full-width silver",
                      },
                      [_vm._v(_vm._s(_vm.proceed[_vm.getCurrentLocale]))]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "sidebar col-sms-6 col-sm-4 col-md-3" },
          [_c("sdr-shared-cart", { attrs: { modulo: _vm.modulo } })],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "index" }, [
      _c("i", { staticClass: "soap-icon-arrow-right circle" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "index" }, [
      _c("i", { staticClass: "soap-icon-arrow-right circle" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }